<script>
const feeFormatter = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 9,
    minimumFractionDigits: 0,
});

export default {
    render(h) {
        return h('span', [
            this.formattedValue,
            this.suffix,
        ]);
    },

    props: {
        value: {
            type: Number,
            default: 0,
        },

        suffix: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            intermediateValue: this.value, // хранится в наносах
        };
    },

    computed: {
        formattedValue() {
            const tons = this.intermediateValue / 1e9;
            return feeFormatter.format(tons).replace(/,/g, '.');
        },
    },

    watch: {
        value(newValue, oldValue) {
            // Mounted value without animation
            if (oldValue === 0 && this.intermediateValue === 0) {
                this.intermediateValue = newValue;
                return;
            }

            this.animate({
                from: this.intermediateValue,
                to: newValue,
                duration: 800,
            });
        },
    },

    methods: {
        animate({ from, to, duration }) {
            const startTime = performance.now();

            const step = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);

                // Animation function
                const eased = 1 - (1 - progress) ** 3;

                this.intermediateValue = from + (to - from) * eased;

                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };

            requestAnimationFrame(step);
        },
    },
};
</script>
